// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"5e430463","223":"d5ace70e","453":"0e7de10c","487":"d4d03b34","819":"8db4c5d5","938":"ca9fb429","949":"b45a256c","987":"310aa1b7","989":"b557b219"}[chunkId] + ".chunk.js";
};